/** @typedef {import('headlight-configurable-application').Pict} Pict */
const PictProvider = require('pict-provider');

class PlantProvider extends PictProvider
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	/**
	 * Get the Plant by ID
	 * @param {String|Number} pPlantID - The Plant ID to search for
	 * @return {Promise<void>}
	 * @async
	 */
	getPlantByID(pPlantID)
	{
		return new Promise((resolve, reject) =>
		{
			if (!pPlantID)
			{
				this.pict.log.error('No Plant ID provided.');
				return reject(new Error('No Plant ID provided.'));
			}

			this.pict.HeadlightRestClient.getJSON(`ProductionPlant/${pPlantID}`, (pError, pBody) =>
			{
				if (pError)
				{
					this.pict.log.error(`Error getting Plant: ${pError}`, pError);
					return reject(pError);
				}
				resolve(pBody);
			});
		});
	}
}

module.exports = PlantProvider;
module.exports.default_configuration = {};
